import { useCookies } from 'react-cookie';
import { useLocation } from 'react-router-dom';
import { navLinks } from '../utils/navbar-links';
import Action from '../navbar/Action';
import Button from '../navbar/Button';
import Logo from '../navbar/Logo';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';

type PropTypes = { children: React.ReactNode };

export default function CommonLayout({ children }: PropTypes) {
    const { pathname } = useLocation();
    const [cookies] = useCookies([
        StoredCookies.USERNAME,
        StoredCookies.REFRESH_TOKEN,
    ]);

    const connected = !!cookies[StoredCookies.REFRESH_TOKEN] && !!cookies[StoredCookies.USERNAME];
    return (
        <div className='w-full relative'>
            {/* <div className="fixed z-[151]">
                <div className=" py-2 px-4 absolute w-[100vw] z-[-1] flex  shadow-sm justify-end bg-gradient-to-b from-blue-50 to-white">
                    <Action connected={connected} />
                </div>
                <nav className=" flex min-h-[100vh] shadow-md  bg-gradient-to-b from-blue-50 to-white min-w-[250px] max-w-[250px]">
                    <div className=" py-2 px-4 flex flex-col gap-0 sm:gap-1 md:gap-2 lg:gap-4 ">
                        <Logo width={"200"} height={"100%"} />
                        {
                            // connected &&
                            navLinks.map((link) => (
                                <Button
                                    key={link.to}
                                    to={link.to}
                                    Icon={link.Icon}
                                    innerText={link.text}
                                    isActive={pathname === link.to}
                                />
                            ))}
                    </div>
                </nav>
            </div> */}
            <div className="fixed z-[151]">
                {/* Top bar with Action aligned to right */}
                <div className="py-2 px-4 absolute w-[100vw] z-[-1] flex shadow-sm justify-end bg-gradient-to-b from-blue-50 to-white">
                    <Action connected={connected} />
                </div>

                {/* Sidebar */}
                <nav className="flex min-h-[100vh] shadow-md bg-gradient-to-b from-blue-50 to-white min-w-[250px] max-w-[250px]">
                    <div className="py-2 px-4 flex flex-col gap-0 sm:gap-1 md:gap-2 lg:gap-4 w-full">
                        {/* Fixed Logo */}
                        <div className="mb-4">
                            <Logo width={"200"} height={"100%"} />
                        </div>

                        {/* Scrollable navLinks */}
                        <div className="overflow-y-auto max-h-[100vh] pr-2 hide-scrollbar">
                            {navLinks.map((link) => (
                                <Button
                                    key={link.to}
                                    to={link.to}
                                    Icon={link.Icon}
                                    innerText={link.text}
                                    isActive={pathname === link.to}
                                />
                            ))}
                        </div>
                    </div>
                </nav>
            </div>

            {children}

        </div>
    );
}
